export const AnalyticsConstants = {
  alertWarning: 'alert warning',
  chanel: 'browser'
};
